import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { HiMenu, HiX, HiHome, HiTrendingUp, HiDocumentText, HiCog } from 'react-icons/hi';

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', icon: HiHome, label: '대시보드' },
    { path: '/trades', icon: HiTrendingUp, label: '거래 내역' },
    { path: '/logs', icon: HiDocumentText, label: '시스템 로그' },
    { path: '/settings', icon: HiCog, label: '설정' },
  ];

  // 페이지 변경 시 메뉴 닫기
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  // 메뉴 열릴 때 body 스크롤 방지
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <>
      {/* 햄버거 메뉴 버튼 - 모바일에서만 표시 */}
      <button
        onClick={() => setIsOpen(true)}
        className="flex md:hidden items-center justify-center w-10 h-10 rounded-lg hover:bg-gray-700 transition-colors"
        aria-label="메뉴 열기"
      >
        <HiMenu className="w-6 h-6 text-white" />
      </button>

      {/* 오버레이 배경 */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
          aria-label="메뉴 닫기"
        />
      )}

      {/* 슬라이드 인 사이드바 */}
      <aside
        className={`
          fixed top-0 left-0 h-full w-64 bg-gray-800 z-50
          transform transition-transform duration-300 ease-in-out md:hidden
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        {/* 헤더 */}
        <div className="h-14 px-4 flex items-center justify-between border-b border-gray-700">
          <h2 className="text-lg font-bold text-blue-500">메뉴</h2>
          <button
            onClick={() => setIsOpen(false)}
            className="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-gray-700 transition-colors"
            aria-label="메뉴 닫기"
          >
            <HiX className="w-6 h-6 text-white" />
          </button>
        </div>

        {/* 네비게이션 */}
        <nav className="p-4 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-gray-700 text-blue-500 border-l-4 border-blue-500'
                    : 'text-gray-400 hover:bg-gray-700 hover:text-white'
                }`
              }
            >
              <item.icon className="text-xl" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default MobileMenu;
